import React, { FC, useState } from 'react'
import { SubQuestionProps } from '../../types'
import { KnowledgeSubQuestion } from '../../../../../types'
import { KnowledgeQuestionSectionWithRelevantQuestion } from './knowledge-question-section-with-relevant-question'
import { KnowledgeQuestionSectionWithoutRelevantQuestion } from './knowledge-question-section-without-relevant-question'
import { KnowledgeQuestion } from '../../trained_questions/knowledge-question'
import { useSubQuestionLogic } from '../../hook/use-sub-question-logic'
import TabTile from '../../../../../../../../data/components/TabTile'

export const KnowledgeSubQuestionElement: FC<SubQuestionProps> = ({
  index,
  subQuestion,
  createNewQuestionCallback,
  feedbackId,
  setSolvedCallback,
  modifyQuestions
}) => {
  const knowledgeSubQuestion = subQuestion as KnowledgeSubQuestion
  const [questionWasChanged, setQuestionWasChanged] = useState<boolean>(false)

  const {
    expanded,
    trainedQuestionExpanded,
    questionCreated,
    trainedQuestions,
    handleToggleExpand,
    handleTrainingQuestionToggleExpand,
    handleCreationNewQuestion,
    deleteTrainedQuestion,
    updateQuestion,
  } = useSubQuestionLogic({
    subQuestionId: subQuestion.subQuestionId,
    feedbackId,
    initialTrainedQuestions: subQuestion.trainedQuestions,
    createNewQuestionCallback,
    setSolvedCallback,
    modifyQuestions,
  })

  const getColor = (): string | undefined => {
    if (questionCreated) return 'rgba(144, 238, 144, 0.8)'
    if (questionWasChanged) return 'rgba(255, 140, 0, 0.6)'
    return undefined
  }

  const renderKnowledgeSection = () => {
    if (subQuestion.mostRelevantQuestion) {
      return (
        <KnowledgeQuestionSectionWithRelevantQuestion
          question={knowledgeSubQuestion.task}
          answer={knowledgeSubQuestion.answer}
          dataSources={knowledgeSubQuestion.isDataPresentInKnowledge}
          onUpdate={updateQuestion}
          buttonIsActive={questionWasChanged}
          mostRelevantQuestion={subQuestion.mostRelevantQuestion}
          onCreateNewQuestion={(question, answer, questionType) => {
            handleCreationNewQuestion(question, answer, questionType)
          }}
          onQuestionWasChanged={setQuestionWasChanged}
          initQuestionType={subQuestion.mostRelevantQuestion.questionType}
        />
      )
    } else {
      return (
        <KnowledgeQuestionSectionWithoutRelevantQuestion
          question={knowledgeSubQuestion.task}
          answer={knowledgeSubQuestion.answer}
          dataSources={knowledgeSubQuestion.isDataPresentInKnowledge}
          onCreateNewQuestion={(question, answer) => {
            handleCreationNewQuestion(question, answer, 'faq')
          }}
          buttonIsActive={questionWasChanged}
          setButtonIsActive={setQuestionWasChanged}
          onTextWasChange={setQuestionWasChanged}
        />
      )
    }
  }

  return (
    <TabTile
      shadowColor={getColor()}
      tab={{
        name: (
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'inline-block',
              maxWidth: '100%',
            }}>{`${index}. ${subQuestion.type.toUpperCase()}: ${knowledgeSubQuestion.task}`}</span>
        ),
      }}
      expanded={expanded}
      onChange={handleToggleExpand}>
      {renderKnowledgeSection()}

      {trainedQuestions && trainedQuestions.length > 0 && (
        <TabTile
          tab={{ name: <span>New Trained Questions</span> }}
          expanded={trainedQuestionExpanded}
          onChange={handleTrainingQuestionToggleExpand}>
          {trainedQuestions.map((q, idx) => (
            <div
              key={q.trainingQuestionId || idx}
              style={{
                padding: '16px',
                borderRadius: '8px',
                background: '#f9f9f9',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                marginBottom: '1rem',
              }}>
              <KnowledgeQuestion
                question={q.question}
                answer={q.answer}
                deleteTrainingQuestionCallback={deleteTrainedQuestion}
                updateQuestionCallback={updateQuestion}
                questionType="trained"
                questionId={q.trainingQuestionId}
                initQuestionType={q.questionType}
              />
            </div>
          ))}
        </TabTile>
      )}
    </TabTile>
  )
}
